export const VIEW_CLASS = '⚙';
export const $hasClassName = Symbol('hasClassName');
export const $classes = Symbol('classes');
export const $deps = Symbol('deps');
export const $type = Symbol('type');

//# sourceMappingURL=constants.js.map